import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LanguageProvider } from './contexts/language.context';
import { CartProvider } from './contexts/cart.context';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
	<HelmetProvider>
		<BrowserRouter>
			<LanguageProvider>
				<CartProvider>
					<App />
				</CartProvider>
			</LanguageProvider>
		</BrowserRouter>
	</HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
